const byteToHex = (value: number) => value.toString(16).padStart(2, "0");

const formatUuidV4 = (bytes: Uint8Array) => {
  const hex = Array.from(bytes, byteToHex);
  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
};

export const getSafeRandomId = () => {
  const cryptoRef = globalThis.crypto;

  if (cryptoRef?.randomUUID) {
    return cryptoRef.randomUUID();
  }

  if (cryptoRef?.getRandomValues) {
    const bytes = new Uint8Array(16);
    cryptoRef.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    return formatUuidV4(bytes);
  }

  throw new Error("Secure random number generation is not supported in this environment.");
};
